import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/customer';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React from 'react';
import { Link } from 'react-router-dom';
import { Tag, Typography } from 'antd';
import $S from 'theme/settings';
import TextBox from 'theme/TextBox';
import Spinner from 'theme/Spinner';
import UserItem from 'theme/auth/UserItem';
import { parameterizedString } from 'theme/utils';
import { Pagination } from 'antd';

// pageContainer
import CustomerList from '_pageContainers/customer/customerList';

const { Title } = Typography;

const CustomerListGrid = (pageContext) => {
  const {
    props: { pending, customers, count },
    customer,
    currentPage,
    changeHandler,
    mailValidation,
    removeFilterParameter,
    pageChangeHandler,
  } = pageContext;

  const { first_name, last_name, phone, email, order_number } = customer;
  const hasQuery = first_name || last_name || phone || email || order_number;

  const renderCustomers = () => {
    return customers.map((customer) => {
      return (
        <Link
          key={customer.pk}
          className='col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 user-search__user-item'
          to={`${$R.CUSTOMER_DETAIL.path}/${customer.pk}`}
        >
          <UserItem
            title={`${customer.first_name} ${customer.last_name}`}
            content={customer.email}
          />
        </Link>
      );
    });
  };

  return (
    <div className='container-fluid user-search headerMargin'>
      <div className='user-search__container'>
        <div className='row user-search__header-container'>
          <div className='col-xs-12 col-md-12 input-area align-self-center'>
            <div className='row flex-row-reverse'>
              <div className='col-md-3'>
                {/* <Link
                  to={$R.NEW_USER.path}
                  className='button pointer user-create-button d-block customer-list__createButton'
                >
                  {$ST.CREATE_NEW_CUSTOMER}
                </Link> */}
              </div>
            </div>
            {$S.hasCustomerOrderFilter && (
              <div className='input-area__label-wrapper customer-list'>
                <label className='label-title'>
                  {$ST.SEARCH_CUSTOMER_BY_ORDER_NUMBER}
                </label>
              </div>
            )}
            {$S.hasCustomerOrderFilter && (
              <div className='mb-70'>
                <TextBox
                  name='order_number'
                  type='text'
                  placeholder={$ST.CUSTOMER_ORDER_NUMBER}
                  value={order_number}
                  onChange={changeHandler}
                />
              </div>
            )}
            {$S.hasMemberFilterHeader && (
              <div className='input-area__label-wrapper customer-list'>
                <label className='label-title'>
                  {$ST.SEARCH_CUSTOMER_BY_MEMBER_INFO}
                </label>
              </div>
            )}
            {$S.hasCustomerFirstNameFilter && (
              <div className='mb-15'>
                <TextBox
                  name='first_name'
                  type='text'
                  placeholder={$ST.CUSTOMER_FIRST_NAME}
                  value={first_name}
                  onChange={changeHandler}
                />
              </div>
            )}
            {$S.hasCustomerLastNameFilter && (
              <div className='mb-15'>
                <TextBox
                  name='last_name'
                  type='text'
                  placeholder={$ST.CUSTOMER_LAST_NAME}
                  value={last_name}
                  onChange={changeHandler}
                />
              </div>
            )}
            {$S.hasCustomerPhoneFilter && (
              <div className='mb-15' style={{
                position: 'relative',
              }}>
                  {phone && (
                    <span style={{
                      position: 'absolute',
                      top: '19px',
                      left: '12px',
                      zIndex: 2,
                    }}>+</span>
                  )}
                  <TextBox
                      type='tel'
                      classes="symbol"
                      masked
                      placeholder={$ST.CUSTOMER_PHONE_NUMBER}
                      mask={[
                        '0',
                        '0',
                        '3',
                        '2',
                        ' ',
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                      ]}
                      name='phone'
                      value={phone}
                      onChange={(value) => changeHandler(value, 'phone')}
                      styles={{
                        paddingLeft: phone ? '20px' : '10px',
                      }}
                    />
              </div>
            )}
            {$S.hasCustomerEmailFilter && (
              <div className='mb-15'>
                <TextBox
                  name='email'
                  type='text'
                  placeholder={$ST.CUSTOMER_EMAIL_ADDRESS}
                  value={email}
                  onChange={changeHandler}
                />
              </div>
            )}
            {(mailValidation
              || (email === null)) && (
              <p className='e-mail-validation'>{$ST.MAIL_VALIDATION}</p>
            )}
          </div>
        </div>
      </div>

      {hasQuery && (
        <div className='user-search__container body'>
          <div className='row'>
            <div className='col-12'>
              <div className='user-search__body-title'>
                <Title level={4}>{$ST.SEARCH_CRITERIA_HEADER}:</Title>
                {order_number && (
                  <Tag
                    closable
                    color='blue'
                    onClose={() => removeFilterParameter('order_number')}
                  >{`${$ST.ORDER_NUMBER}: ${order_number}`}</Tag>
                )}

                {first_name && (
                  <Tag
                    closable
                    color='blue'
                    onClose={() => removeFilterParameter('first_name')}
                  >
                    {`${$ST.FIRST_NAME}: ${first_name}`}
                  </Tag>
                )}

                {last_name && (
                  <Tag
                    color='blue'
                    closable
                    onClose={() => removeFilterParameter('last_name')}
                  >
                    {`${$ST.LAST_NAME}: ${last_name}`}
                  </Tag>
                )}

                {phone && (
                  <Tag
                    color='blue'
                    closable
                    onClose={() => removeFilterParameter('phone')}
                  >
                    {`${$ST.PHONE}: ${phone}`}
                  </Tag>
                )}

                {email && (
                  <Tag
                    color='blue'
                    closable
                    onClose={() => removeFilterParameter('email')}
                  >
                    {`${$ST.EMAIL}: ${email}`}
                  </Tag>
                )}

                {parameterizedString($ST.SEARCH_RESULT_INFORMATION, count)}
              </div>
            </div>
          </div>
          <div className='col-12'>
            <div className='row'>{!pending && renderCustomers()}</div>
            <Pagination
              className='pagination-wrapper'
              total={count}
              onChange={(e) => pageChangeHandler(e)}
              defaultCurrent={1}
              current={currentPage}
            />
          </div>
        </div>
      )}
      {pending && <Spinner />}
    </div>
  );
};

export default CustomerList(CustomerListGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/customer/customerList/index.js